/**
 * @file AlertDialog.js
 * @version 1.1.1
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2025-11-17
 * @modified 2026-07-27
 */

import React from 'react';
import { createPortal } from 'react-dom';
import './ConfirmDialog.css';

function AlertDialog({
  isOpen,
  title = 'Excel Agri System',
  message,
  onClose,
  buttonText = 'OK',
  type = 'info' // warning, info, error, success
}) {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'success':
        return 'check_circle';
      case 'info':
      default:
        return 'info';
    }
  };

  const getIconColor = () => {
    switch (type) {
      case 'error':
        return 'var(--color-error)';
      case 'warning':
        return 'var(--color-warning)';
      case 'success':
        return 'var(--color-success)';
      case 'info':
      default:
        return 'var(--color-info)';
    }
  };

  return createPortal(
    <div className="confirm-dialog-overlay">
      <div className="confirm-dialog">
        <div className="confirm-dialog-header">
          <span
            className="material-symbols-rounded"
            style={{ color: getIconColor(), fontSize: '24px' }}
          >
            {getIcon()}
          </span>
          <h3>{title}</h3>
          <button
            type="button"
            className="confirm-dialog-close"
            aria-label="Close"
            onClick={onClose}
          >
            <span className="material-symbols-rounded">close</span>
          </button>
        </div>
        <div className="confirm-dialog-body">
          {typeof message === 'string' ? (
            <p>
              {message.split('\n').map((line, i, arr) => (
                <React.Fragment key={i}>
                  {line}
                  {i < arr.length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
          ) : message}
        </div>
        <div className="confirm-dialog-actions">
          <div>
            <button
              className="btn-round"
              onClick={onClose}
            >
              <div className="icon-wrapper">
                <span className="material-symbols-rounded">check</span>
              </div>
              <span className="btn-label">{buttonText}</span>
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default AlertDialog;
